const state = {
  internetConnectionAvailable: true,
  weonConnectionAvailable: true,
  reconnectionConfirmation: false,
  connectionProblemDialog: false,
  connectionWebRTCStatus: 'disconnected',
  connectionProblemWebRTC: false,
  connectionProblemWebRTCDevice: false,
};

export default state;
